export const API_KEY_STATUS = {
  active: "active",
  inactive: "inactive",
} as const;

export type TApiKeyStatus =
  (typeof API_KEY_STATUS)[keyof typeof API_KEY_STATUS];

export type TApiKey = {
  _id: string;
  orgId: string;
  name: string;
  userId: string;
  status: TApiKeyStatus;
  scope: string;
  createdAt: string;
  updatedAt: string;
  iat: number;
};

export type TApiKeyCreateResponse = TApiKey & {
  token: string; // JWT token - only returned on creation
};

export type TApiKeyCount = {
  count: number;
};

export type TApiUsage = {
  orgId: string;
  usage: number;
};

export type TAutomationLog = {
  timestamp: string;
  orgId: string;
  orgName: string | null;
  storyId: string;
  storyTitle: string | null;
  versionId: string;
  versionTitle: string | null;
  versionUrl: string | null;
  versionCreatorId: string;
  apiKeyId: string;
  status: string;
  message: string;
  latency: string | null;
};

export type TAutomationStats = {
  totalQueries: number;
  successQueries: number;
  failedQueries: number;
  successRate: number;
};

export type TApiKeyStats = {
  successCount: number;
  errorCount: number;
};

export type TAutomationQueryParams = {
  query: string | string[];
  dateFrom: string;
  dateTo: string;
  storyId?: string;
  versionId?: string;
  apiKeyId?: string;
  status?: string;
  versionCreatorId?: string;
};

export type TAutomationQueryResponse<T extends string | string[]> =
  T extends string
    ? TAutomationLog[] | TAutomationStats
    : Record<string, TAutomationLog[] | TAutomationStats>;
